import React from 'react';
import { ChatMessage } from '../ChatMessage/ChatMessage';
import { Flex } from '../Flex/Flex';
import { Grid } from '../Grid/Grid';
/**
 * @public
 */
export function ChatMessageContainer({
  messageMaxWidth = '90%',
  messages
}) {
  return React.createElement(Grid, {
    gap: 2,
    height: '100%',
    overflowY: 'scroll',
    p: 3
  }, messages?.map(message => React.createElement(Flex, {
    key: message.message,
    justifyContent: message.variation === 'outgoing' ? 'flex-end' : 'flex-start'
  }, React.createElement(ChatMessage, {
    ...message,
    maxWidth: messageMaxWidth
  }))));
}